import React from 'react';
import { withRouter } from 'react-router';

/**
 * 此组件用于绑定实例属性到 window
 * @class BandWindowProps
 * @extends {React.Component}
 */
class BandWindowProps extends React.Component {
  render() {
    window.g_app_history = this.props.history; // 将 history 绑定到全局
    return null;
  }
}

export default withRouter(BandWindowProps);
